import React from "react";
import { Link } from "react-router-dom";
import { FaPlus } from "react-icons/fa6";
import cash_delivery from "../assets/images/cash-delivery.png";

const PaymentSection = ({
  activeTab,
  paymentMethod,
  setPaymentMethod,
  cards,
  cardId,
  setCardId,
  removeCard,
  addCardRedirect
}) => {
  return (
    <div className="payment-methods p-3 mx-2">
      <h5 className="mt-2">Payment Methods</h5>

      {/* Payment Status Indicator */}
      {localStorage.getItem('selected_card_id') && (
        <div className="alert alert-info mb-3" role="alert">
          <i className="bi bi-credit-card me-2"></i>
          Card ready for payment! You can now place your order.
        </div>
      )}
      <div className="methods">
        {activeTab === 'delivery' ? (
          <div className="cash-delivery row border-bottom">
            <div className="col-11">
              <img src={cash_delivery} alt="COD" /> <span>Cash On Delivery</span>
            </div>
            <div className="col-1">
              <input
                type="checkbox"
                className="checkbox cart-checkbox"
                onClick={() => setPaymentMethod('COD')}
                checked={paymentMethod === 'COD'}
                readOnly
              />
            </div>
          </div>
        ) : (
          <div className="cash-delivery row border-bottom">
            <div className="col-11">
              <img src={cash_delivery} alt="COP" /> <span>Cash On Pickup</span>
            </div>
            <div className="col-1">
              <input
                type="checkbox"
                className="checkbox cart-checkbox"
                onClick={() => setPaymentMethod('COP')}
                checked={paymentMethod === 'COP'}
                readOnly
              />
            </div>
          </div>
        )}

        {cards && cards.map((card, index) => (
          <div className="cash-delivery row border-bottom" key={card.id || index}>
            <div className="col-11">
              {card.scheme}
              <span className="x-num">xxxx xxxx {card.last4}</span>
            </div>
            <div className="col-1 d-flex align-items-center">
              <button className="btn btn-transparent" onClick={() => removeCard(card.id, true)}>
                <i className="bi bi-trash"></i>
              </button>
              <input
                type="checkbox"
                className="checkbox cart-checkbox"
                checked={paymentMethod === 'Card' && cardId === card.id}
                onClick={() => { setPaymentMethod('Card'); setCardId(card.id) }}
                readOnly
              />
            </div>
          </div>
        ))}

        <Link to={addCardRedirect || '/add-card'} className="new-card text-white">
          <FaPlus />
          <p className="mt-3 ms-3">Add New Card</p>
        </Link>
      </div>
    </div>
  );
};

export default PaymentSection;
